import Vue from 'vue'
import VueI18n from 'vue-i18n'

import zhCN from './zh-CN'
import enUS from './en-US'
import esES from './es-ES'
import deDE from './de-DE'
import ruRU from './ru-RU'

Vue.use(VueI18n)
const messages = {
  'zh': zhCN,
  'en': enUS,
  'es': esES,
  'de': deDE,
  'ru': ruRU
}

export function getLanguage () {
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'zh'
}

const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages,
  silentTranslationWarn: true
})
export default i18n



// WEBPACK FOOTER //
// ./src/assets/lang/index.js